export enum MaterialTypeEnum {
  /** 图片 */
  Image = 1,
  /** 文件 */
  File = 2,
  /** 视频 */
  Video = 3,
  /** 音频 */
  Audio = 4,
}

const commonList = ["txt", "doc", "docx", "xls", "xlsx", "pdf"];
const imageList = ["jpg", "jpeg", "png", "gif", "bmp"];
const videoList = ["mp4"];
const audioList = ["wav", "mp3"];

/** 获取素材类型列表 */
export function getMaterialAccessListByType(type: MaterialTypeEnum) {
  if (type === MaterialTypeEnum.Image) {
    return imageList;
  } else if (type === MaterialTypeEnum.Video) {
    return videoList;
  } else if (type === MaterialTypeEnum.Audio) {
    return audioList;
  } else {
    return [...commonList, ...imageList, ...videoList, ...audioList];
  }
}
